import { render, staticRenderFns } from "./ElementPricingBox.vue?vue&type=template&id=da9202aa&"
import script from "./ElementPricingBox.vue?vue&type=script&lang=js&"
export * from "./ElementPricingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports